import { render } from "./ModuleRedeployment.vue?vue&type=template&id=3efcb0bc"
import script from "./ModuleRedeployment.vue?vue&type=script&lang=js"
export * from "./ModuleRedeployment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__